// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/31081baf322c53b9da12.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"13c701077afcd15d88b7","166":"2e045d3e54a704ddca96","167":"be5027c136eb69319744"}[chunkId] + ".chunk.js";
};